import React from 'react'
import { Link } from 'react-router-dom'
import Service_1 from '../../../assets/images/services/01.png'
import Service_2 from '../../../assets/images/services/02.png'
import Service_3 from '../../../assets/images/services/03.png'
import Service_4 from '../../../assets/images/services/04.png'

const Service = () => {
    return (
        <>
            <section id="services-three" className="services-three-main-block">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-3 col-lg-6 col-md-6">
                            <div className="services-three-block">
                                <div className="services-three-img">
                                    <img
                                        src={Service_1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="services-three-dtls">
                                    <h6 className="services-three-heading jakarta-font">
                                        <Link to="#" title="">
                                            Free Shipping
                                        </Link>
                                    </h6>
                                    <p>1st Online Order and This Order Over price is $49.00</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6">
                            <div className="services-three-block">
                                <div className="services-three-img">
                                    <img
                                        src={Service_2}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="services-three-dtls">
                                    <h6 className="services-three-heading jakarta-font">
                                        <Link to="#" title="">
                                            Amazing Deals
                                        </Link>
                                    </h6>
                                    <p>Deals for your next generations amazing Dealing experience</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6">
                            <div className="services-three-block">
                                <div className="services-three-img">
                                    <img
                                        src={Service_3}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="services-three-dtls">
                                    <h6 className="services-three-heading jakarta-font">
                                        <Link to="#" title="">
                                            Expert Teams
                                        </Link>
                                    </h6>
                                    <p>1st Online Order and This Order Over price is $49.00</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6">
                            <div className="services-three-block">
                                <div className="services-three-img">
                                    <img
                                        src={Service_4}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                                <div className="services-three-dtls">
                                    <h6 className="services-three-heading jakarta-font">
                                        <Link to="#" title="">
                                            Support Center
                                        </Link>
                                    </h6>
                                    <p>1st Online Order and This Order Over price is $49.00</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Service
